/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Wizard_Discard_DescriptionInputs */



/**
* | output |
* | --- |
* | "What you have written so far will be lost." |
*
* @param {Agent_Wizard_Discard_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_wizard_discard_description = /** @type {((inputs?: Agent_Wizard_Discard_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Wizard_Discard_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was Sie bisher geschrieben haben, geht verloren.")
	return /** @type {LocalizedString} */ ("What you have written so far will be lost.")
});